import { InterventiModule } from '../Interventi/Interventi.module';
import { SediAggiuntiveComponent } from './component/sedi-aggiuntive/sedi-aggiuntive.component';
import { AttivitaClienteComponent } from './attivita-cliente/attivita-cliente.component';
import { EditPersonaComponent } from './edit-persona/edit-persona.component';
import { DettaglioPersonaComponent } from './component/dettaglio-persona/dettaglio-persona.component';
import { ButtonsPipe, FormAziendaComponent } from './form-azienda/form-azienda.component';
import { ListaAziendeComponent } from './lista-aziende/lista-aziende.component';
import { ProfiloComponent } from './profilo/profilo.component';
import { AuthGuardAmministrazione } from '../Login/_guards/AuthGuardAmministrazione';
import {ListaUtentiComponent, noAdminFilter} from './lista-utenti/lista-utenti.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FeatherModule } from 'angular-feather';
import {NgMultiSelectDropDownModule} from '../../LibrerieCustom/MultiselectDropdown'
// tslint:disable-next-line:max-line-length
import { Camera, Heart, Github, Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeftCircle, ArrowLeft, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Award, BarChart2, BarChart, BatteryCharging, Battery, BellOff, Bell, Bluetooth, Bold, BookOpen, Book, Bookmark, Box, Briefcase, Calendar, CameraOff, Cast, CheckCircle, CheckSquare, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Chrome, Circle, Clipboard, Clock, CloudDrizzle, CloudLightning, CloudOff, CloudRain, Cloud, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Delete, Disc, DollarSign, DownloadCloud, Download, Droplet, Edit, Edit2, Edit3, ExternalLink, EyeOff, Eye, Facebook, FastForward, Feather, Figma, FileMinus, FilePlus, FileText, File, Film, Filter, Flag, Folder, FolderMinus, FolderPlus, Framer, Frown, Gift, GitBranch, GitCommit, GitMerge, GitPullRequest, Gitlab, Globe, Grid, HardDrive, Hash, Headphones, HelpCircle, Hexagon, Home, MoreHorizontal, Image, Inbox, Info, Instagram, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Lock, LogIn, LogOut, Mail, MapPin, Map, Maximize, Maximize2, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, MinusCircle, MinusSquare, Minus, Monitor, Moon, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Octagon, Package, Paperclip, PauseCircle, Pause, PenTool, Percent, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, Phone, PhoneOff, PhoneOutgoing, PieChart, Play, PlayCircle, Plus, PlusCircle, PlusSquare, Pocket, Power, Printer, Radio, RefreshCcw, RefreshCw, Repeat, Rewind, RotateCcw, RotateCw, Rss, Save, Scissors, Search, Send, Server, Settings, Share, Share2, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, SkipBack, SkipForward, Slack, Slash, Sliders, Smartphone, Smile, Speaker, Square, Star, StopCircle, Sun, Sunrise, Sunset, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Tool, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Video, VideoOff, Voicemail, Volume, Volume1, Volume2, VolumeX, Watch, Wifi, WifiOff, Wind, XCircle, XOctagon, XSquare, X, Youtube, Zap, ZapOff, ZoomIn, ZoomOut } from 'angular-feather/icons';
import { NgbModalModule, NgbModule, NgbPagination, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HttpClientModule } from '@angular/common/http';

import { SharedModule } from '../shared/Shared.module';
import { RuoliListComponent } from './ruoli-list/ruoli-list.component';
import {ProgettiModule} from "../Progetti/Progetti.module";
import {RMAModule} from "../rma/rma.module";
import {TranslateModule} from "@ngx-translate/core";
import { ReferentiComponent } from './component/referenti/referenti.component';
import { EditAttivitaClienteComponent } from './edit-attivita-cliente/edit-attivita-cliente.component';
import {TaskModule} from "../task/task.module";
import {FormazioneModule} from "../formazione/formazione.module";
import { ImportAziendeComponent } from './import-aziende/import-aziende.component';
import {ChecklistsSettingsComponent} from "./checklists-settings/checklists-settings.component";
import {ImportReferentiComponent} from "./import-Referenti/import-referenti.component";
import {RegistroPresenzeComponent} from "./registro-presenze/registro-presenze.component";
import { GanttModule } from '@syncfusion/ej2-angular-gantt'
import {MonitoraggioComponent} from "./monitoraggio/monitoraggio.component";
import { CrmComponent } from './crm-component/crm.component';
// tslint:disable-next-line:max-line-length
const icons = {Camera, Heart, Github, Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter, AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown, ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeftCircle, ArrowLeft, ArrowRight, ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpLeft, ArrowUpRight, AtSign, Award, BarChart2, BarChart, BatteryCharging, Battery, BellOff, Bell, Bluetooth, Bold, BookOpen, Book, Bookmark, Box, Briefcase, Calendar, CameraOff, Cast, CheckCircle, CheckSquare, Check, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ChevronsDown, ChevronsLeft, ChevronsRight, ChevronsUp, Chrome, Circle, Clipboard, Clock, CloudDrizzle, CloudLightning, CloudOff, CloudRain, Cloud, CloudSnow, Code, Codepen, Codesandbox, Coffee, Columns, Command, Compass, Copy, CornerDownLeft, CornerDownRight, CornerLeftDown, CornerLeftUp, CornerRightDown, CornerRightUp, CornerUpLeft, CornerUpRight, Cpu, CreditCard, Crop, Crosshair, Database, Delete, Disc, DollarSign, DownloadCloud, Download, Droplet, Edit, Edit2, Edit3, ExternalLink, EyeOff, Eye, Facebook, FastForward, Feather, Figma, FileMinus, FilePlus, FileText, File, Film, Filter, Flag, Folder, FolderMinus, FolderPlus, Framer, Frown, Gift, GitBranch, GitCommit, GitMerge, GitPullRequest, Gitlab, Globe, Grid, HardDrive, Hash, Headphones, HelpCircle, Hexagon, Home, MoreHorizontal, Image, Inbox, Info, Instagram, Italic, Key, Layers, Layout, LifeBuoy, Link, Link2, Linkedin, List, Loader, Lock, LogIn, LogOut, Mail, MapPin, Map, Maximize, Maximize2, Meh, Menu, MessageCircle, MessageSquare, Mic, MicOff, Minimize, Minimize2, MinusCircle, MinusSquare, Minus, Monitor, Moon, MoreVertical, MousePointer, Move, Music, Navigation, Navigation2, Octagon, Package, Paperclip, PauseCircle, Pause, PenTool, Percent, PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, Phone, PhoneOff, PhoneOutgoing, PieChart, Play, PlayCircle, Plus, PlusCircle, PlusSquare, Pocket, Power, Printer, Radio, RefreshCcw, RefreshCw, Repeat, Rewind, RotateCcw, RotateCw, Rss, Save, Scissors, Search, Send, Server, Settings, Share, Share2, Shield, ShieldOff, ShoppingBag, ShoppingCart, Shuffle, Sidebar, SkipBack, SkipForward, Slack, Slash, Sliders, Smartphone, Smile, Speaker, Square, Star, StopCircle, Sun, Sunrise, Sunset, Tablet, Tag, Target, Terminal, Thermometer, ThumbsDown, ThumbsUp, ToggleLeft, ToggleRight, Tool, Trash, Trash2, Trello, TrendingDown, TrendingUp, Triangle, Truck, Tv, Twitch, Twitter, Type, Umbrella, Underline, Unlock, Upload, UploadCloud, User, UserCheck, UserMinus, UserPlus, UserX, Users, Video, VideoOff, Voicemail, Volume, Volume1, Volume2, VolumeX, Watch, Wifi, WifiOff, Wind, XCircle, XOctagon, XSquare, X, Youtube, Zap, ZapOff, ZoomIn, ZoomOut};
const routes: Routes = [
  {
    path: 'personale',
    data: {
      title: "menu.PersonaleLabel",
      urls: [{ title: "menu.PersonaleLabel",url:"/listautenti/personale" }],
    },
    component: ListaUtentiComponent,
    canActivate: [AuthGuardAmministrazione]
  },{
    path: 'personale/:type',
    data: {
      title: "menu.PersonaleLabel",
      urls: [{ title: "menu.PersonaleLabel",url:"/listautenti/personale" }],
    },
    component: ListaUtentiComponent,
  },
  {
    path: 'profilo',
    data: {
      title: "Profilo.profilo",
      urls: [{ title: "Profilo.profilo",url:"/listautenti/profilo" }],
    },
    component: ProfiloComponent,
  },
  {
    path: 'dipendente',
    data: {
      title: "Profilo Dipendente",
      urls: [{ title: "menu.PersonaleLabel", url: "/listautenti/personale" }, { title: "Profilo Dipendente",url:"/listautenti/dipendente" }],
    },
    component: EditPersonaComponent,
  },

  {
    path: 'aziende',
    data: {
      title: "menu.clienti",
      urls: [{ title: "menu.clienti",url:"/listautenti/aziende" }],
    },
    component: ListaAziendeComponent,
  },
  {
    path: 'aziende/:type',
    data: {
      title: "menu.clienti",
      urls: [{ title: "menu.clienti" }],
    },
    component: ListaAziendeComponent,
  },
  {
    path: 'formazienda',
    data: {
      title: "cliente.title",
      urls: [{ title: "menu.clienti", url: "/listautenti/aziende"},{ title: "cliente.title",url:"/listautenti/formazienda" }],
    },
    component: FormAziendaComponent,
  },
  {
    path: 'formazienda/:type',
    data: {
      title: "cliente.title",
      urls: [{ title: "cliente.title",url:"/listautenti/formazienda" }],
    },
    component: FormAziendaComponent,
  },
  {
    path: 'formazienda/:type/:id',
    data: {
      title: "cliente.title",
      urls: [{ title: "cliente.title" }],
    },
    component: FormAziendaComponent,
  },
  { path: 'formazienda/:type/:id/:idCongelamento',
    data: {
      title: "cliente.title",
      urls: [{ title: "cliente.title" }],
    },
    component: FormAziendaComponent,
  },
  {
    path: 'roles',
    data: {
      title: "Ruoli",
      urls: [{ title: "Ruolo" }],
    },
    component: RuoliListComponent,
  },
  {
    path: 'profile',
    data: {
      title: "Info cliente",
      urls: [{ title: "Info cliente",url:"/Cliente/profile" }],
    },
    component: FormAziendaComponent,
  },
  {
    path: 'profile/:tab',
    data: {
      title: "Info cliente",
      urls: [{ title: "Info cliente",url:"/Cliente/profile" }],
    },
    component: FormAziendaComponent,
  },
  {
    path: 'check/settings',
    data: {
      title: "Checks",
    },
    component: ChecklistsSettingsComponent,
  },
  {
    path: 'presenze',
    data: {
      title: "Presenze",
    },
    component: RegistroPresenzeComponent,
  },
  {
    path: 'monitoraggio',
    data: {
      title: "Monitoraggio P.V.",
    },
    component: MonitoraggioComponent,
  },
];
@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FeatherModule,
        FeatherModule.pick(icons),
        NgMultiSelectDropDownModule,
        NgbPaginationModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        NgbModalModule,
        PerfectScrollbarModule,
        HttpClientModule,
        FeatherModule,
        SharedModule,
        InterventiModule,
        ProgettiModule,
        RMAModule,
        TranslateModule,
        TaskModule,
        FormazioneModule,
      GanttModule
    ],
  declarations: [
    ListaUtentiComponent,
    ProfiloComponent,
    ListaAziendeComponent,
    FormAziendaComponent,
    DettaglioPersonaComponent,
    EditPersonaComponent,
    AttivitaClienteComponent,
    SediAggiuntiveComponent,
    RuoliListComponent,
    ReferentiComponent,
    EditAttivitaClienteComponent,
    noAdminFilter,
    ImportAziendeComponent,
    ChecklistsSettingsComponent,
    ImportReferentiComponent,
    RegistroPresenzeComponent,
    MonitoraggioComponent,
    ButtonsPipe,
    CrmComponent
  ]
})
export class AdminModule {}
